export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-gdpr",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2018-06-19 17:04+0200",
	"Last-Translator": "Viktor Pracht <viktor.pracht@open-xchange.com>",
	Language: "",
	"Language-Team": "",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0"
};
export default {
	headers: headers,
	"\u0000%s is an easy to use suite of applications to help you work more efficiently. Take a quick tour to view all the help and support resources available to you.\u0001": [
	"%s ist eine leicht zu verwendende Anwendungs-Suite, mit der Sie Ihre Arbeit effizienter erledigen können. Machen Sie eine schnelle Tour, um sämtliche verfügbaren Hilfe- und Unterstützungsressourcen einzusehen."
],
	"\u0000Access all apps by clicking this icon:\u0001": [
	"Greifen Sie mit Klick auf dieses Icon auf alle Apps zu:"
],
	"\u0000Click on this gear icon to find the settings menu where you can set your language, create signatures or manage your mail filter rules and much more.\u0001": [
	"Klicken Sie auf das Zahnradsymbol, um ins Einstellungsmenü zu gelangen. Dort können Sie Ihre Sprache wählen, Signaturen erstellen oder Ihre E-Mail-Filterregeln verwalten und vieles mehr."
],
	"\u0000Click the question mark to get access to all the onboarding support. Here you can take the Getting started tour for %s, take the Guided tour for a specific app and much more.\u0001": [
	"Klicken Sie auf das Fragezeichen, um Unterstützung beim Onboarding zu erhalten. Hier können Sie die Einstiegstour für %s oder die Tour für eine bestimmte App starten und vieles mehr."
],
	"\u0000Continue\u0001": [
	"Fortfahren"
],
	"\u0000Customize your %s in Settings\u0001": [
	"Passen Sie Ihre %s in den Einstellungen an"
],
	"\u0000Help and Getting Started:\u0001": [
	"Hilfe und Einstieg:"
],
	"\u0000If you need more help with %s you can find more tutorials by visiting this page.\u0001": [
	"Wenn Sie noch mehr Hilfe mit %s benötigen, können Sie weitere Tutorials auf dieser Seite finden."
],
	"\u0000One last thing…\u0001": [
	"Eine Sache noch…"
],
	"\u0000Please watch this video to get started:\u0001": [
	"Bitte sehen Sie sich für den Einstieg dieses Video an:"
],
	"\u0000See tutorials\u0001": [
	"Tutorials ansehen"
],
	"\u0000We suggest you bookmark this page for easy access later.\u0001": [
	"Wir würden vorschlagen, diese Seite für leichten zukünftigen Zugriff als Lesezeichen zu speichern."
],
	"\u0000Welcome to %s, your webmail and professional business suite.\u0001": [
	"Willkommen bei %s, Ihrer Webmail- und professionellen Business-Suite."
],
	"\u0000You can also get help connecting your device in the dropdown menu.\u0001": [
	"Hilfe zum Anschließen Ihrer Geräte erhalten Sie ebenfalls im Einstellungsmenü."
]
};
